var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_543_36407",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_543_36407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info_2",
    d: "M7.50033 11.666H8.50033V7.83268H7.50033V11.666ZM8.00033 6.69168C8.15288 6.69168 8.28077 6.64007 8.38399 6.53685C8.48721 6.43363 8.53883 6.30574 8.53883 6.15318C8.53883 6.00063 8.48721 5.87274 8.38399 5.76952C8.28077 5.6664 8.15288 5.61485 8.00033 5.61485C7.84777 5.61485 7.71988 5.6664 7.61666 5.76952C7.51344 5.87274 7.46183 6.00063 7.46183 6.15318C7.46183 6.30574 7.51344 6.43363 7.61666 6.53685C7.71988 6.64007 7.84777 6.69168 8.00033 6.69168ZM8.00149 14.8327C7.12549 14.8327 6.3021 14.6665 5.53133 14.334C4.76055 14.0016 4.0901 13.5504 3.51999 12.9805C2.94988 12.4106 2.49849 11.7405 2.16583 10.97C1.83327 10.1996 1.66699 9.3764 1.66699 8.50052C1.66699 7.62452 1.83321 6.80113 2.16566 6.03035C2.4981 5.25957 2.94927 4.58913 3.51916 4.01902C4.08905 3.4489 4.75921 2.99752 5.52966 2.66485C6.3001 2.33229 7.12327 2.16602 7.99916 2.16602C8.87516 2.16602 9.69855 2.33224 10.4693 2.66468C11.2401 2.99713 11.9105 3.44829 12.4807 4.01818C13.0508 4.58807 13.5022 5.25824 13.8348 6.02868C14.1674 6.79913 14.3337 7.62229 14.3337 8.49818C14.3337 9.37418 14.1674 10.1976 13.835 10.9683C13.5025 11.7391 13.0514 12.4096 12.4815 12.9797C11.9116 13.5498 11.2414 14.0012 10.471 14.3338C9.70055 14.6664 8.87738 14.8327 8.00149 14.8327ZM8.00033 13.8327C9.48921 13.8327 10.7503 13.316 11.7837 12.2827C12.817 11.2493 13.3337 9.98824 13.3337 8.49935C13.3337 7.01046 12.817 5.74935 11.7837 4.71602C10.7503 3.68268 9.48921 3.16602 8.00033 3.16602C6.51144 3.16602 5.25033 3.68268 4.21699 4.71602C3.18366 5.74935 2.66699 7.01046 2.66699 8.49935C2.66699 9.98824 3.18366 11.2493 4.21699 12.2827C5.25033 13.316 6.51144 13.8327 8.00033 13.8327Z",
    fill: "#15182C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.90135e6947876bf85afbdeb679368588.svg";
export { ForwardRef as ReactComponent };